import { PortalDsAlert } from 'src/components/portal-design-system';

export function PortalSyncNotConfiguredBanner() {
  return (
    <PortalDsAlert
      variant="warning"
      title="User management is unavailable"
    >
      <code className="rounded bg-[#F0F1F5] px-1 py-0.5 text-[12px]">
        PORTAL_SYNC_SECRET
      </code>
      {' '}
      is not configured on the portal backend. Contact an admin to set this environment variable
      (and ensure
      {' '}
      <code className="rounded bg-[#F0F1F5] px-1 py-0.5 text-[12px]">
        SELF_SERVICE_BASE_URL
      </code>
      {' '}
      is set).
    </PortalDsAlert>
  );
}
